import { CANDIDATE_STATUS, CandidateStatus } from '@/services/candidates/types';
import { CampaignJobboard } from '@/shared/legacy/contexts/SelectedCampaignContext/SelectedCampaignContext.types';

export type CandidateReachoutEligibility = {
  contact_info?: { email?: string | string[]; phone?: string };
  communicationOptOut?: boolean;
  communication_opt_out?: boolean;
  status?: CandidateStatus;
  activeJobBoard?: CampaignJobboard;
};

export type RjCommHubEligibilityGates = {
  isWaCommunicationAgentEnabled?: boolean;
};

const hasEmail = (candidate: CandidateReachoutEligibility): boolean => {
  const email = candidate.contact_info?.email;
  if (email == null) return false;
  if (Array.isArray(email)) return email.some((e) => Boolean(e?.trim()));
  return Boolean(String(email).trim());
};

export const candidateHasEmail = hasEmail;

const hasPhone = (candidate: CandidateReachoutEligibility): boolean => Boolean(candidate.contact_info?.phone?.trim());

const isOptedOut = (candidate: CandidateReachoutEligibility): boolean =>
  candidate.communication_opt_out === true || candidate.communicationOptOut === true;

const hasValidContactForRj = (candidate: CandidateReachoutEligibility, gates: RjCommHubEligibilityGates) =>
  hasEmail(candidate) || (hasPhone(candidate) && gates.isWaCommunicationAgentEnabled === true);

export const canBeReachoutViaRjCommHub = (
  candidate: CandidateReachoutEligibility,
  gates: RjCommHubEligibilityGates = {},
) =>
  hasValidContactForRj(candidate, gates) &&
  !isOptedOut(candidate) &&
  candidate.activeJobBoard !== CampaignJobboard.Indeed &&
  candidate.status !== CANDIDATE_STATUS.MATCHED &&
  candidate.status !== CANDIDATE_STATUS.CONTACTED &&
  candidate.status !== CANDIDATE_STATUS.HIDDEN;
